import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NavigationModule } from 'src/core-lib/navigation/navigation.module';
import { PipeModule } from 'src/core-lib/pipes/pipe.module';
import { VarDirective } from 'src/core-lib/var/var.directive';
import { CustomerButtonComponent } from 'src/customer/components/customer-button/customer-button.component';
import { TagManagerModule } from 'src/externals/tag-manager/tag-manager.module';
import { BlockListOutletComponent } from 'src/layout/grid/components/block-list-outlet/block-list-outlet.component';
import { MediaModule } from 'src/layout/media/media.module';
import { CatalogSelectorComponent } from './catalog-selector/catalog-selector.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { OverlayBasketComponent } from './overlay-basket/overlay-basket.component';
import { OverlayDropdownComponent } from './overlay-dropdown/overlay-dropdown.component';
import { OverlayLanguagesComponent } from './overlay-languages/overlay-languages.component';
import { OverlayMenuComponent } from './overlay-menu/overlay-menu.component';
import { OverlaySearchComponent } from './overlay-search/overlay-search.component';
import { GetTemplatePipe } from './pipe/get-template.pipe';
import { GoogleMapLinkPipe } from './pipe/google-map-link.pipe';
import { HasNestedMenuPipe } from './pipe/has-nested-menu.pipe';
import { MenuToCtaPipe } from './pipe/menu-to-cta.pipe';
import { UnNestedMenuPipe } from './pipe/un-nested-menu.pipe';
import { SearchBarComponent } from './search-bar/search-bar.component';



@NgModule({
    declarations: [
        HeaderComponent,
        FooterComponent,
        OverlayMenuComponent,
        OverlaySearchComponent,
        HasNestedMenuPipe,
        UnNestedMenuPipe,
        OverlayDropdownComponent,
        SearchBarComponent,
        GetTemplatePipe,
        OverlayLanguagesComponent,
        GoogleMapLinkPipe,
        MenuToCtaPipe,

    ],
    imports: [
        OverlayBasketComponent,
        TagManagerModule,
        CommonModule,
        MediaModule,
        NavigationModule,
        TranslateModule,
        ReactiveFormsModule,
        PipeModule,
        BlockListOutletComponent,
        VarDirective,
        CustomerButtonComponent,
        CatalogSelectorComponent
    ],
    exports: [HeaderComponent, FooterComponent]
})
export class ChromeModule {}
